import {
  ConnectionTypeEnum,
  EICStatusEnum,
  ServiceTypeEnum,
  SortDirectionEnum,
  State,
} from "../Premises/types";
import { RequestChannelEnum, RequestTypeEnum } from "../Changes/types";

export type DraftsTableRow = {
  serviceType: ServiceTypeEnum;
  connectionType: ConnectionTypeEnum;
  address: string;
  id: string;
  lastEdited: string;
  status: string;
  statusText: string;
  state: State;
  requestType: RequestTypeEnum;
  requestChannel: RequestChannelEnum | null;
  eicStatus?: EICStatusEnum | null;
};

export enum SortByEnum {
  DRAFT_STATUS = "DRAFT_STATUS",
  ADDRESS = "ADDRESS",
  CONNECTION_TYPE = "CONNECTION_TYPE",
  REQUEST_ID = "REQUEST_ID",
  UPDATED = "UPDATED",
}

export interface FetchDrafts {
  page?: number;
  limit?: number;
  sortDirection?: SortDirectionEnum;
  sortBy?: SortByEnum;
  incremental?: boolean;
}

export type DraftsTableRows = DraftsTableRow[];
